// extracted by mini-css-extract-plugin
module.exports = {"Title--level-1":"Title_Title--level-1__StuWO","Title--level-2":"Title_Title--level-2__pvRey","Title--level-3":"Title_Title--level-3__kImik"};